export const LEWOO_API_URL = process.env.REACT_APP_LEWOO_API_URL || 'http://localhost:8000';
export const LEWOO_TOKEN_KEY = 'lewoo_token';
export const LEWOO_USER_KEY = 'lewoo_user';
